import AuthController from "../Api/authController";
import { clearLegacyTokens } from "../Api/tokenController";
import { AuthUser } from "../interfaces/AuthUser";
import { useGlobalState } from "../context/context";

export const useUser = () => {
    const { state, dispatch } = useGlobalState();

    const setSession = (user: AuthUser | null, authReady = true) => {
        dispatch({ type: 'setAuthSession', user, authReady });
    };

    const setIsAuth = (isAuth: boolean) => {
        if (!isAuth) setSession(null);
        else dispatch({ type: 'setIsAuth', isAuth });
    };

    const setStateIsAuthInvoice = (isAuthInvoice: boolean) => {
        dispatch({ type: 'setIsAuthInvoice', isAuthInvoice });
    };

    const autoLogin = async () => {
        clearLegacyTokens();
        const res = await AuthController.autoLogin();
        setSession(res.ok && res.user ? res.user : null);
    };

    const logout = async () => {
        await AuthController.logout();
        setSession(null);
    };

    const hasPermission = (permission: string) => {
        const permissions = state.currentUser?.permissions || [];
        if (state.currentUser?.role?.toLowerCase() === 'superadmin' || permissions.includes('*') || permissions.includes(permission)) return true;
        return permissions.includes(`${permission.split('.')[0]}.*`);
    };

    return {
        setIsAuth,
        setStateIsAuthInvoice,
        setSession,
        autoLogin,
        logout,
        hasPermission,
        isAuth: state.isAuth,
        isAuthInvoice: state.isAuthInvoice,
        authReady: state.authReady,
        currentUser: state.currentUser,
    };
};
